// src/configs/mixpanelConfig.js
import mixpanel from 'mixpanel-browser';

// Replace with your Mixpanel token
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

// Initialize Mixpanel with proper error handling
if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV !== 'production',
    track_pageview: false, // We'll handle this manually
    persistence: 'localStorage',
    // api_host: "https://api-js.mixpanel.com"
  });
  console.log('Mixpanel initialized successfully');
} else {
  console.warn('Mixpanel token is missing. Tracking will be disabled.');
}

// Safe wrapper for Mixpanel
const Mixpanel = {
  identify: (id) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.identify(id);
    }
  },
  
  alias: (id) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.alias(id);
    }
  },
  
  track: (name, props) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.track(name, props);
    }
  },
  
  trackPageView: (url) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.track('Page View', {
        url,
        title: document.title,
        referrer: document.referrer
      });
    }
  },
  
  people: {
    set: (props) => {
      if (MIXPANEL_TOKEN) {
        mixpanel.people.set(props);
      }
    },
    setOnce: (props) => {
      if (MIXPANEL_TOKEN) {
        mixpanel.people.set_once(props);
      }
    }
  },
  
  reset: () => {
    if (MIXPANEL_TOKEN) {
      mixpanel.reset();
    }
  }
};

export default Mixpanel;